<template>
  <div>
    <q-toggle color="red-10" true-value="0" false-value="1" v-model="sale_state">
      <span class="text-red-10 text-bold">فقط سفارشات نهایی نشده نمایش داده شوند</span>
    </q-toggle>
    <q-table
        :data="orderHistoryList"
        row-key="Sale_Num"
        wrap-cells
        flat
        :filter="filter"
        :pagination.sync="pagination">
      <template v-slot:header>
        <q-input filled label="جستجو در لیست" v-model="filter" />
      </template>
      <template v-slot:body="props">
        <q-tr :props="props" class="my-class" v-if="props.row.Sale_State === parseInt(sale_state)">
          <q-td>
            <q-card flat>
              <q-card-section class="no-padding">
                <div class="row">
                  <div class="col-1 q-mr-md">
                    <q-btn round dense color="indigo" padding="none" size="lg" icon="info"
                           @click="showDetails(props.row)"/>
                    <q-btn v-if="props.row.Sale_State===+0" padding="none" flat size="lg" round class="q-mt-xs"
                           color="indigo"
                           icon="edit" @click="editOrder(props.row.Sale_Num, props.row.Sale_State)"/>
                    <q-btn v-if="props.row.Sale_State===0" flat padding="none" size="lg" round class="q-mt-xs"
                           color="positive" icon="check"
                           @click="setSaleStateFlag(props.row.Sale_Num)">
                      <q-tooltip>
                        تایید سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn round flat icon="timeline" color="indigo" @click="showOrderTimeLine(props.row)">
                      <q-tooltip>
                        رهگیری سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="props.row.Sale_State===1 && props.row.Sale_StateModir===0 && $store.state.roles.some(v=>['admin','can_final_order'].includes(v))"
                        flat padding="none" size="lg" round class="q-mt-xs"
                        color="positive" icon="done_all"
                        @click="setFinalSaleState(props.row)">
                      <q-tooltip>
                        تایید نهایی سفارش
                      </q-tooltip>
                    </q-btn>
<!--                    <q-btn-->
<!--                        v-if="props.row.Sale_State===1 && !props.row.finance && $store.state.roles.some(v=>['admin','can_issue_finance_from_factory'].includes(v))"-->
<!--                        flat  round-->
<!--                        color="positive" icon="done_all"-->
<!--                        @click="issueFinanceDocument(props.row)">-->
<!--                      <q-tooltip>-->
<!--                        صدور سند مالی-->
<!--                      </q-tooltip>-->
<!--                    </q-btn>-->
                  </div>
                  <div class="col-10">
                    <div class="row">
                      <div class="col">
                        <q-chip :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white"
                                icon="qr_code">سفارش ({{ props.row.Sale_Num }})
                        </q-chip>
                        <q-chip v-if="props.row.Factor_Num" :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white"
                                icon="qr_code">فاکتور ({{ props.row.Factor_Num }})
                        </q-chip>
                        <q-chip v-if="props.row.Hava_Num" :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white"
                                icon="qr_code">حواله ({{ props.row.Hava_Num }})
                        </q-chip>

                        <q-chip :size="$q.screen.lt.md?'md':'md'" square color="red" icon="event" outline>تاریخ سفارش
                          ({{ props.row.Sale_Date }})
                        </q-chip>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <q-chip :size="$q.screen.lt.md?'md':'md'" square color="purple" icon="functions"
                                text-color="white">
                          {{ props.row.Sale_Count }} قلم
                        </q-chip>
                        <q-chip :size="$q.screen.lt.md?'md':'md'" square color="red-14" icon="attach_money"
                                text-color="white">
                          {{ props.row.Sale_Pay | toCurrency }} ریال
                        </q-chip>
                      </div>
                    </div>
                    <div class="row">
                      <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="business">{{
                          props.row.CompName
                        }}
                      </q-chip>
                    </div>
                  </div>
                </div>
              </q-card-section>
              <q-card-section class="no-padding">
                <q-banner rounded v-if="props.row.LastTraceinfo" dense
                          :class="props.row.LastTraceinfo==='حذف'?'bg-red-8 text-white':'bg-blue-8 text-white'"
                          row.Sale_Num>
                  {{ props.row.LastTraceinfo==='حذف'?'لطفا از سیستم حذف گردد.': props.row.LastTraceinfo}}
                  <div v-if="props.row.ReasonDescription && props.row.ReasonDescription!==props.row.LastTraceinfo">
                    <q-separator color="white"/>
                    {{ props.row.ReasonDescription }}
                  </div>
                </q-banner>
              </q-card-section>
            </q-card>
          </q-td>
        </q-tr>
      </template>
    </q-table>

    <q-dialog
        maximized
        v-model="showOrderDetailsDialog">
      <order-details v-if="!$q.screen.lt.md" :store_id="null" :hava_num="null" :sale-num="selectedSaleNum"/>
      <OrderDetailsMobile v-if="$q.screen.lt.md" :store_id="null" :hava_num="null" :sale-num="selectedSaleNum"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="showTimeLineDialog">
      <OrderTimeLine :sale-date="selectedSaleDate" :remain-ordered="0" :sale-num="parseInt(selectedSaleNum)"/>
    </q-dialog>
  </div>
</template>

<script>
import OrderDetails from "@/components/customers/OrderDetails";
import {mapActions} from "vuex";
import OrderTimeLine from "@/components/OrderTrace/OrderTimeLine";
import OrderDetailsMobile from "@/components/customers/OrderDetailsMobile";

export default {
  name: "OrderHistory",
  components: {OrderDetailsMobile, OrderTimeLine, OrderDetails},
  props: ['orderHistoryList', 'defaultSaleState'],
  data() {
    return {
      filter:'',
      showOrderDetailsDialog: false,
      showTimeLineDialog:false,
      selectedSaleNum: '',
      sale_state: false,
      selectedSaleDate:'',
      pagination: {
        rowsPerPage: 10
      },
    }
  },
  methods: {
    ...mapActions({
      setSaleState: 'Orders/setSaleState',
      setFinalOrder: 'Orders/setSaleFinalState',
      issueFactorDocument: 'Requests/issueFinanceDocument',

    }),
    issueFinanceDocument(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'سند حسابداری فاکتور صادر شود؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.issueFactorDocument(row.Sale_Num).then((res) => {
          if (res.result === -1) {
            this.$q.notify({
              message: res.msg,
              color: 'negative',
              position: 'top',
              type: 'negative'
            });
          } else {
            this.$q.notify({
              message: `فاکتور در سیستم محاسبان به شماره سند ${res.msg} به ثبت رسید`,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }


          this.$emit('refresh-data');
        })
      })

    },
    showDetails(row) {
      this.selectedSaleNum = row.Sale_Num;
      this.showOrderDetailsDialog = true;
    },
    editOrder(sale_num, state) {
      this.$router.push(`/orders-list/${sale_num}/${state}`);
    },
    setFinalSaleState(row) {
      this.setFinalOrder(row.Sale_Num).then((res) => {
        if (res.data.msg === 'success') {
          this.$q.notify({
            message: `سفارش ${row.Sale_Num}تایید گردید `,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
          row.Sale_StateModir = 1
        }
      })
    },
    setSaleStateFlag(sale_num) {
      this.$q.dialog({
        title: 'تاییدیه نقد بودن خرید',
        message: 'آیا خرید طرف معامله نقدی می باشد؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.setSaleState({
          sale_num: sale_num,
          cash: true
        }).then((res) => {
          if (res.data.msg === "success") {
            this.$q.notify({
              message: `سفارش ${sale_num}نهایی گردید `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
        }).catch(() => {
          this.$q.notify({
            message: 'طرف معامله اعتبار کافی ندارد',
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        });
      }).onCancel(() => {
        this.setSaleState({
          sale_num: sale_num,
          cash: false
        }).then((res) => {
          if (res.data.msg === "success") {
            this.$q.notify({
              message: `سفارش ${sale_num}نهایی گردید `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
        }).catch(() => {
          this.$q.notify({
            message: 'طرف معامله اعتبار کافی ندارد',
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        });
      }).onDismiss(() => {

      })
    },
    showOrderTimeLine(row) {
      this.selectedSaleNum = row.Sale_Num;
      this.selectedSaleDate = row.Sale_Date
      this.showTimeLineDialog = true;
    },
  },
  created() {
    if (this.defaultSaleState === undefined) {
      this.sale_state = 1

    } else {
      this.sale_state = this.defaultSaleState
    }
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
